import { trace } from 'rytm-helpers'
import { store } from './../tsaw/store'
import { getMainSoundMeta, skipMainBackward, skipMainForward } from '../tsaw/lib/tsaw_mixer'
import { userPauseSoundMain, userResumeSoundMain, seekSoundMain } from './../tsaw/actions/actions_audio'

export const SKIP_JUMP_SECONDS = 15
const FPS = 2
let navSoundVisible = false
let navSoundExpanded = false
let mainPaused = false
/**
 * ### INIT ###
 */
 export const initTsawNavSound = () => {
  // Document CLICK
  document.addEventListener("click", onDocClick, false)
 }
// nav sound is visible on stage
export const navSoundShowed = () => {
  navSoundVisible = true
  enterAnimationFrame()
  const soundNav = document.getElementById("soundNav")
  soundNav.classList.add("show")
}
// nav sound is removed from stage
export const navSoundHidden = () => {
  navSoundVisible = false
  const soundNav = document.getElementById("soundNav")
  soundNav.classList.remove("show")
}

 // ##########################
// ### Doc event handlers ###
// Doc click
const onDocClick = (e) => {
  if (e.target.classList.contains("open-sound-panel")) {
    e.preventDefault()
    onNavSoundOpen(e)
  } else if (e.target.classList.contains("close-sound-panel")) {
    e.preventDefault()
    onNavSoundClose(e)
  } else if (e.target.classList.contains("toggle-audio")) {
    e.preventDefault()
    toggleAudio(e)
  } else if (e.target.classList.contains("skip-backward-main")) {
    e.preventDefault()
    skipBackward(e)
  } else if (e.target.classList.contains("skip-forward-main")) {
    e.preventDefault()
    skipForward(e)
  } else if (e.target.classList.contains("waveform-main")) {
    e.preventDefault()
    seekAudio(e)
  }
  // click outside nav sound panel
  if (!e.target.classList.contains("open-sound-panel")
      && !e.target.classList.contains("close-sound-panel")
      && document.documentElement.classList.contains("chapter-sound-open")) {
    const boxNavExpand = document.querySelector(".box-sound-nav-expanded")
    if (boxNavExpand && !boxNavExpand.contains(e.target)) {
      onNavSoundClose(e)
    }
  }

}

// ###################
// ### NAV Methods ###
// expand sound panel
const onNavSoundOpen = (e) => {
  document.documentElement.classList.add("chapter-sound-open")
  navSoundExpanded = true
}
// collapse sound panel
const onNavSoundClose = (e) => {
  document.documentElement.classList.remove("chapter-sound-open")
  navSoundExpanded = false
}
// set timecode for NAV visual display 
const updateTimecode = () => {
  const meta = getMainSoundMeta()
  const timeRemaining = meta.duration - meta.time
  const list = [...document.querySelectorAll('.timecode-main')]
  const timeStr = formatTimecode(timeRemaining)
  list.forEach((el) => {
    el.innerHTML = (timeRemaining > 0 ? '-&nbsp;' : '&nbsp;&nbsp;') + timeStr
    // el.innerHTML = timeStr
  })
}
// update waveform
const updateWaveforms = () => {
  // const meta = getMainSoundMeta()
  // if (meta.time && meta.duration) {
  //   const list = [...document.querySelectorAll('.waveform-main')]
  //   const perc = parseInt(meta.time / meta.duration * 100)
  //   list.forEach((el) => {
  //     // const wave = el.querySelector(".wave-masked")
  //     // wave.style.clipPath = "inset(0 " + (100 - perc) + "% 0 0)"
  //   })
  // }
}
const formatTimecode = (timeInSeconds) => {
  if (!timeInSeconds) {
    return '00:00'
  }
  const sec_num = parseInt(timeInSeconds)
  let hours   = Math.floor(sec_num / 3600);
  let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
  let seconds = sec_num - (hours * 3600) - (minutes * 60);
  if (hours   < 10) {hours   = "0"+hours;}
  if (minutes < 10) {minutes = "0"+minutes;}
  if (seconds < 10) {seconds = "0"+seconds;}
  return minutes + ':' + seconds
}
// Toggle play / pause
const toggleAudio = (e) => {
  const state = store.getState()
  if (state.reducerAudio.sound_main_usr_paused) {
    userResumeSoundMain()
  } else {
    userPauseSoundMain()
  }
}
// 15 sec backward
const skipBackward = (e) => {
  skipMainBackward()
}
// 15 sec forward
const skipForward = (e) => {
  skipMainForward()
}
// Waveform click - seek
const seekAudio = (e) => {
  const rect = e.target.getBoundingClientRect()
  const perc = (e.clientX - rect.x) / rect.width
  const meta = getMainSoundMeta()
  if (meta.duration) {
    seekSoundMain(perc)
  }
}

// ########################
// ### ANIMATION FRAMES ###
// fps animation related
let now, delta
let interval = 1000/FPS
let then = Date.now()
// enterAnimationFrame (request animation frame + FPS)
const enterAnimationFrame = () => {
  if (!navSoundVisible) {
    return
  }
  requestAnimationFrame(enterAnimationFrame)
  now = Date.now()
  delta = now - then
  if (delta > interval) {
    drawFrame()
    then = now - (delta % interval)
  }
}
// drawFrame frame... 
const drawFrame = () => {
  // update timecode
  updateTimecode()
  // update waveform
  updateWaveforms()
}
